import React from 'react'
import LookQuestionType from './lookQuestionType'
import { component_tool } from '../../../../tool'
// const questionTypeConfig = data => WizTableForm.Config.questionType(this, { apiParams: { type: data } })

//配置项
let componentName = 'questionType'
let ref;

const columns = (data, parent) => {
    let columnsRef = []
    columnsRef = columnsRef.concat([
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        name: "type",
        searchItem: {
          type: "hidden",
        },
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createBy",
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createTime",
        formItem: {
          type: "hidden",
        }
      },
    ])
    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentId",
          dataIndex: "parentId",
          dict: {
            wizReplaceData: "treeData",
            defalutType: []
          },
          formItem: {
            type: 'treeselect',
            allowClear: true,
            // ...questionTypeConfig(data),
            // diy: WizTableForm,
            // selectType: 'radio',
          },
        }
      ])
    }
    columnsRef = columnsRef.concat([
      {
        title: "分类名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 40,
          placeholder: '分类名称最多输入40个字',
          rules: [
            {
              required: true,
              message: '请输入分类类型名称'
            },
            // {
            //   pattern: /^[^\s]*$/,
            //   message: '分类类型名称录入信息不能包含空格'
            // }
          ],
        },
        searchItem: {},
        tableItem: {width: 200,}
      },
    ])

    if (data == 1 || data == 2) {
      columnsRef = columnsRef.concat([
        {
          title: "分类编码",
          name: "code",
          dataIndex: "code",
          formItem: {
            maxlength: 50,
            placeholder: '编码不能超过50个字',
            rules: [{
              required: true,
              message: '请输入编码',
            }]
          },
          tableItem: {},
        },
      ])
    }

    if (data == 18) {
      columnsRef = columnsRef.concat([
        {
          title: "分类编码",
          name: "code",
          dataIndex: "code",
          formItem: {
            maxlength: 50,
            placeholder: '编码不能超过50个字',
            rules: [{
              required: true,
              message: '请输入编码',
            }]
          },
          tableItem: {},
          searchItem: {}
        },
      ])
    }

    if (data == 1) {
      columnsRef = columnsRef.concat([{
        title: "排序",
        name: "sort",
        dataIndex: "sort",
        tableItem: {},
        formItem: {
          type: 'number',
          initialValue: 1,
          min: 1,
          max: 9999,
        }
      },])
    }

    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentName",
          dataIndex: "parentName",
          tableItem: { width: 200,}
        },])
    }
    columnsRef = columnsRef.concat([
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          {code: 1, codeName: "有效"},
          {code: 0, codeName: "无效"}
        ],
        formItem: {
          type: "select",
          initialValue: 1
        }
      },
      {
        title: "简介",
        name: "intro",
        dataIndex: "intro",
        tableItem: {
        },
        formItem: {
          type: 'textarea',
          placeholder: '请输入简介,最多100字',
          maxlength: 100,
        },
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {
          width: 80,
        },
        dict: [
          {code: 1, codeName: "有效"},
          {code: 0, codeName: "无效"}
        ],
        searchItem: {
          type: "select"
          // mode: 'multiple',
        },
      },
   ])

   if (data == 2) {
    columnsRef = columnsRef.concat([
      {
        title: '类型',
        name: 'mode',
        dataIndex: 'mode',
        dict: [
          { code: 0, codeName: '考试' },
          { code: 1, codeName: '练习' },
        ],
        searchItem: {
          type: 'select'
        },
      },
      {
        title: '类型',
        name: 'modeList',
        dataIndex: 'modeList',
        dict: [
          { code: 0, codeName: '考试' },
          { code: 1, codeName: '练习' },
        ],
        tableItem: {
          type: 'checkbox'
        },
        formItem: {
          type: 'checkbox',
          rules: [
            {
              required: true,
              message: '请选择类型'
            }
          ],
        }
      },
    ])
   }

    return columnsRef
  }
;

const templateConfig = (data) => {
  const {type, parent, pathname} = data;
  const columnsInfo = columns(type, parent);
  let returnObj = {
      name: "WizTableList",
      params: {
        columns: columnsInfo,
        searchBarProps: {
          buttonSort: ['add', 'delete', 'batchImport', 'export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: "export", children: "导出", type: "export"},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'batchImport',
              custom: true,
              params: {icon: 'import', children: '批量导入', type: 'import'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: `${pathname}/fileImport`,
                  record: {type: type}
                }
              },
            }
          ],
          collapse: false,
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'authorityManagement'],
        commonOperate: {
          add: true,
          update: true,
          delete: true,
          look: false
        },
        rowOperateView: [
          type == '2' ? {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "questionTypeLook",
                modalParams: {
                  title: "查看题目分类",
                  cancelButtonProps: {style: {height: 0, width: 0}},
                  style: {minWidth: 700},
                  footer: null,
                  diy: (e) => {
                    return (
                      <LookQuestionType
                        key={'questionTypeLook' + e.record.id}
                        {...e}
                        type={type}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  onOk: () => {
                    ref._ok();
                  },
                  width: 600
                },
              }
            }
          } : {},
          {
            key: "authorityManagement",
            custom: true,
            params: {children: "权限管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: 'push',
                pathname: `${pathname}/auth`,
                record: {type: type}
              }
            }
          }
        ]
      }
  }
  if (parent !== 'no') {
    returnObj.params.siderBarProps ={
        key: "nodeTree",
        searchKey: "id",
        params: {type}
    }
  }
  return {
    mainProps: {},
    content:returnObj
  }
};


let reduxTemplateCofig = (args) => {
  const {type, parent} = args;
  const apis = {
    list: {
      path: `${componentName}/${type === '2' || type === '18' ? 'normalListByPage' : 'listByPage'}`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, pageSize: 10, type}
      }
    },

    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {type}
      }
    },
    treeData: {
      path: `${componentName}/${type === '2' || type === '18' ? 'normalNodeList' : 'nodeList'}`,
      payload: {
        key: `${componentName}@treeData`,
        apiParams: {type}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {type}
      }
    },
    update: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@upd`,
        apiParams: {type}
      }
    },
    delete: {
      path: `${componentName}/del`,
      payload: {
        key: `${componentName}@del`,
        apiParams: {type}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    }
  };
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
